<template>
<!-- IT解决方案 -->
    <div>
        <div class="topImgs">
            <div>
                <span>科技基因驱动胤石不断创新，自主研发一系列自动化运营工具,并在专家团队的数据分析下，赋能店站运营效率提升</span>
            </div>
        </div>
        <div class="ITSolutionsImg">
            <div class="itImg1">
                <div>
                    <span>企业IT信息系统整体搭建</span>
                </div>
            </div>
            <div class="imgfour">
                <div class="imgOne">
                    <div class="itImg2">
                        <div>
                            <span>企业私有云及VPS方案输出，保障账户安全</span>
                        </div>
                    </div>
                    <div class="itImg3">
                        <div>
                            <span>企业跨境ERP定制开发</span>
                        </div>
                    </div>
                </div>
                <div class="imgTwo">
                    <div class="itImg4">
                        <div>
                            <span>智能化仓库管理</span>
                        </div>
                    </div>
                    <div class="itImg5">
                        <div>
                            <span>可视化供应链管理系统，数字化赋<br>能供应链上下游</span>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
    name: 'YinshiOffcialwebsiteITSolutions',

    data() {
        return {
            
        };
    },

    mounted() {
        
    },

    methods: {
        ...mapMutations(['GoTop']),
    },    
    created(){
        this.$store.state.currentRouter = this.$route.path  //获取当前页面路由
        this.GoTop()
    }
};
</script>

<style lang="scss" scoped>
    // 顶部图片
    .topImgs{
        background: url(../../assets/img/industrialChain/iTjiejuefangan.jpg);
        background-size:100% 100%;
        height: 650px;
        display: flex;
        justify-content: center;
        align-items: center;
        div{
            width: 1000px;
            padding:20px 50px;
            background: #03115eb3;
            margin-top: -15px;
            text-align: center;
        }
        span{
            font-size: 36px;
            font-family: Microsoft YaHei, Microsoft YaHei-Bold;
            font-weight: 700;
            color: #ffffff;
            line-height: 67px;
        }
    }
    .ITSolutionsImg{
        padding: 70px 270px;
        display: flex;
        justify-content: center;
        overflow: hidden;
        span{
            font-family: Heavy;
            font-size: 80px;
            font-weight: 900;
            transform: scale(0.25);
            color: #3b589a;
            -webkit-text-stroke: 2.1px #ffffff;
            white-space: nowrap;
            text-align: center;
        }
        .itImg1{
            width: 450px;
            height: 615px;
            background: url(../../assets/img/industrialChain/ITjiejuefangan_05.jpg);
            background-size:100% 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            div{
                width: 100%;
                height: 100%;
                background: rgba(0, 0, 0, 0.144);
                display: flex;
                justify-content: center;
                align-items: center;
                transition: .2s;
            }
            div:hover{
                background: rgba(0, 0, 0, 0.312);
            }
            div:hover span{
                color: #45F0FF !important;
                -webkit-text-stroke: 0px #ffffff !important;
                font-weight: 400 !important;
            }
        }
        
        .itImg2,.itImg3,.itImg4,.itImg5{
            width: 450px;
            height: 300px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-left: 10px;
            transition: .3s;
            cursor: pointer;
            div{
                width: 100%;
                height: 100%;
                background: rgba(0, 0, 0, 0.144);
                display: flex;
                justify-content: center;
                align-items: center;
                transition: .2s;
            }
            div:hover{
                background: rgba(0, 0, 0, 0.312);
            }
            div:hover span{
                color: #45F0FF !important;
                -webkit-text-stroke: 0px #ffffff !important;
                font-weight: 400 !important;
            }
        }
        // .itImg2:hover,.itImg3:hover,.itImg4:hover,.itImg5:hover{
        //     transform: scale(1.03);
        // }
        .itImg2{
            background: url(../../assets/img/industrialChain/ITjiejuefangan_07.jpg);
            background-size:100% 100%;
        }
        
        .itImg3{
            background: url(../../assets/img/industrialChain/ITjiejuefangan_09.jpg);
            background-size:100% 100%;
        }
        .itImg4{
            background: url(../../assets/img/industrialChain/ITjiejuefangan_13.jpg);
            background-size:100% 100%;
        }
        .itImg5{
            background: url(../../assets/img/industrialChain/ITjiejuefangan_14.jpg);
            background-size:100% 100%;
        }
        // 四张小图片
        .imgfour{
            // margin-left: 10px;
            .imgOne,.imgTwo{
                display: flex;
            }
            .imgTwo{
                margin-top: 10px;
            }
        }
    }
</style>